import {
  type CountryCode,
  isValidPhoneNumber,
  parsePhoneNumberFromString,
} from "libphonenumber-js";

const DEFAULT_COUNTRY: CountryCode = "BR";

export const PhoneHelpers = {
  format(phone: string | null | undefined, country: CountryCode = DEFAULT_COUNTRY): string {
    if (!phone) return "";
    const parsed = parsePhoneNumberFromString(phone, country);
    if (parsed) {
      return parsed.formatInternational();
    }
    return phone;
  },

  isValid(phone: string, country: CountryCode = DEFAULT_COUNTRY): boolean {
    return isValidPhoneNumber(phone, country);
  },

  getE164(phone: string, country: CountryCode = DEFAULT_COUNTRY): string | null {
    const parsed = parsePhoneNumberFromString(phone, country);
    return parsed ? parsed.format("E.164") : null;
  },

  getUri(phone: string, country: CountryCode = DEFAULT_COUNTRY): string {
    const parsed = parsePhoneNumberFromString(phone, country);
    return parsed ? parsed.getURI() : `tel:${phone.replace(/\D/g, "")}`;
  },

  formatInternational(phone: string, format: "E.164" | "INTERNATIONAL" | "NATIONAL" = "E.164"): string {
    try {
      const parsed = parsePhoneNumberFromString(phone);
      return parsed ? parsed.format(format) : phone;
    } catch {
      return phone;
    }
  },

  validateInternational(phone: string, country?: CountryCode): boolean {
    try {
      return isValidPhoneNumber(phone, country);
    } catch {
      return false;
    }
  },
};
